import fetchRequest from '../util/fetch'
import errUtil from '../util/error'

const query = `mutation LocalityUpdateMutation (
  $workspace: ID!,
  $id: ID!,
  $data: LocalityInput!
) {
  localityUpdate (
    workspace: $workspace
    id: $id
    data: $data
  ) {
    id
  }
}`

async function requestLocalityUpdate (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('locality-update', errors)
  }
  return data.localityUpdate
}

export default requestLocalityUpdate
